/**
 * Selected Images Bar - Shows thumbnails of selected reference images
 */

import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { SelectedImage } from './ChatArea';

interface Props {
  images: SelectedImage[];
  onRemove: (imageId: string) => void;
}

export function SelectedImagesBar({ images, onRemove }: Props) {
  const { t } = useTranslation();

  return (
    <div className="border-t border-neutral-200 dark:border-neutral-800 px-3 pt-2">
      <p className="text-xs text-neutral-500 mb-1">
        {t('chatImage.selectedImages', { count: images.length })}
      </p>
      <div className="flex gap-2 overflow-x-auto pb-1">
        {images.map((img) => (
          <div key={img.id} className="relative shrink-0">
            <img
              src={img.url}
              alt=""
              className="h-14 w-14 rounded-md object-cover"
            />
            <button
              type="button"
              onClick={() => onRemove(img.id)}
              className="absolute -top-1 -right-1 rounded-full bg-neutral-800 p-0.5 text-white hover:bg-red-600 transition-colors"
            >
              <X className="h-3 w-3" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
